{
  "WHATSAPP_TEMPLATE_MGMT": {
    "TITLE": "Szablony",
    "DESCRIPTION": "Zobacz szablony wiadomości zsynchronizowane ze swoich skrzynek WhatsApp. Aby utworzyć lub edytować szablon, zarządzaj nim u swojego dostawcy.",
    "COUNT": "Liczba szablonów: {n}",
    "LEARN_MORE": "Dowiedz się więcej o szablonach WhatsApp",
    "SYNC_TEMPLATES": "Synchronizuj szablony",
    "SYNC_SUCCESS": "Rozpoczęto synchronizację szablonów dla wszystkich skrzynek WhatsApp. Zmiany mogą być widoczne po kilku minutach.",
    "PARTIAL_SYNC_ERROR": "Rozpoczęto synchronizację szablonów dla części skrzynek WhatsApp, ale pozostałych nie udało się zsynchronizować.",
    "SYNC_ERROR": "Nie udało się rozpocząć synchronizacji szablonów. Spróbuj ponownie.",
    "SEARCH_PLACEHOLDER": "Szukaj według treści lub nazwy...",
    "MANAGE_IN_META": "Zarządzaj w Meta",
    "LOADING": "Ładowanie szablonów WhatsApp...",
    "EMPTY": "Nie znaleziono szablonów WhatsApp.",
    "NO_RESULTS": "Żaden szablon nie pasuje do filtrów.",
    "FETCH_ERROR": "Nie udało się wczytać szablonów WhatsApp. Spróbuj ponownie.",
    "PARTIAL_FETCH_ERROR": "Nie udało się wczytać niektórych szablonów WhatsApp. Spróbuj ponownie.",
    "LAST_SYNC_ATTEMPT": "Ostatnia próba synchronizacji {date}",
    "MORE_INBOXES": "+{n}",
    "STATUSES": {
      "UNSUBMITTED": "Nie przesłano do zatwierdzenia w WhatsApp"
    },
    "FILTERS": {
      "ALL_INBOXES": "Wszystkie skrzynki",
      "ALL_LANGUAGES": "Wszystkie języki",
      "ALL_TYPES": "Wszystkie typy"
    },
    "TYPES": {
      "TEXT": "Tekst",
      "IMAGE": "Obraz",
      "VIDEO": "Wideo",
      "DOCUMENT": "Dokument",
      "CALL_TO_ACTION": "Wezwanie do działania",
      "COPY_CODE": "Kopiuj kod"
    },
    "PREVIEW": {
      "TITLE": "Podgląd szablonu",
      "DESCRIPTION": "Zobacz, jak ten szablon wygląda w WhatsApp.",
      "OPEN": "Podgląd {name}",
      "CLOSE": "Zamknij podgląd",
      "DETAILS": "Szczegóły szablonu",
      "STATUS": "Status",
      "TYPE": "Typ treści",
      "CATEGORY": "Kategoria",
      "LANGUAGE": "Język",
      "INBOXES": "Skrzynki"
    }
  }
}
